import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { Helmet } from 'react-helmet';
import Main from "../../components/Layout/Main";
import ThreeStar from '../../components/Dividers/ThreeStar';
import Section from '../../components/Layout/Section/Section';
import InnerContainer from '../../components/Layout/InnerContainer/InnerContainer';
import CoverImage from "../../components/CoverImage";
import Star from '../../components/Dividers/star';
import EditorialPortrait from '../../components/EditorialPortrait';
import LargeEditorial from '../../components/LargeEditorial'
import PreviewCompatibleImage from '../Utils/PreviewCompatibleImage';
import InsightBlocks from '../../components/InsightBlocks';
import ChimeVideoPreShow from '../../../static/video/CHIME_PRESHOW_ACT_2.mp4';
import MainShowVideoAct1 from '../../../static/video/MAIN_SHOW_ACT_1_CHIME.mp4';
import Act9Video from '../../../static/video/MAIN_SHOW_ACT_9_CHIME_PUSH_BNA_winner.mp4';
import ChimeVotingDeliveryVideo from '../../../static/video/Velocity_Chime_VMA_VOTING_DELIVERY_DDT_2.mp4';
import DojaTyTweet from '../../../static/video/Doja-TY-tweet.mp4';
import TipsVideo from '../../../static/video/Velocity_Chime_EVERGREEN_FINAL_Digital.mp4';
import PushBNAChatBotVideo from '../../../static/video/PUSH-BNA-Chatbot-Video2_Trim.mp4';
import StatisticBlocks from '../../components/StatisticBlocks';
import Wave from '../Dividers/wave';
import Wave3 from '../Dividers/wave3';
import PressQuotes from '../../components/PressQuotes/PressQuotes';


import "./chime.scss";

const Chime = () => {
  const { markdownRemark } = useStaticQuery(graphql`
    query ChimeQuery {
      markdownRemark(frontmatter: { pageId: { eq: "partner-chime" } }) {
        frontmatter {
          components {
            type
            headline
            body {
              line
            }
            logo {
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
            }
            quotes {
              quote
              source
            }
            attr
            image {
              childImageSharp {
                fluid(maxWidth: 2048, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
              extension
              publicURL
            }
            blocks {
              headline
              headline2
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
              body
              bullets {
                bullet
              }
            }
            caption
            images {
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
            }
          }
        }
      }
    }
  `)

  function getComponent(name) {
    const components = markdownRemark.frontmatter.components;
    return components.filter(component => component.type === name)[0];
  }

  const CoverImageContent = getComponent("partnerCoverImage");
  const TextBlock2ptFiveContent = getComponent("textBlock2ptFive");
  const EditorialPortraitContent = getComponent("editorialPortraitLeft");
  const ThreeSmallImagesContent = getComponent("3smallImages");
  const ThreeSmallImages2Content = getComponent("3smallImages2");
  const TwoSmallImagesContent = getComponent("3smallImages3");
  const InsightBlocksContent = getComponent("insightBlocks");
  const InsightBlocks2Content = getComponent("insightBlocks2");
  const InsightBlocks3Content = getComponent("insightBlocks3");
  const InsightBlocks4Content = getComponent("insightBlocks4");
  const InsightBlocks5Content = getComponent("insightBlocks5");
  const InsightBlocks6Content = getComponent("insightBlocks6");
  const StatisticsContent = getComponent("statisticsBlocks");
  const Statistics2Content = getComponent("statisticsBlocks2");
  const Statistics3Content = getComponent("statisticsBlocks3");
  const Statistics4Content = getComponent("statisticsBlocks4");
  const Statistics5Content = getComponent("statisticsBlocks5");
  const LargeEditorialContent = getComponent("largeEditorialContent");
  const LargeEditorial2Content = getComponent("largeEditorialContent2");
  const pressQuote1Content = getComponent("pressQuote1");
  const pressQuote2Content = getComponent("pressQuote2");
  const pressQuote3Content = getComponent("pressQuote3");

  return (
    <Main>
        <Helmet>
          <body className="chime" />
        </Helmet>
        <CoverImage
          image={CoverImageContent.image}
          hero="hero"
          logo={CoverImageContent.logo.image}
          />
        <Section customClass={["color-block", "bg-green"]}>
          <InnerContainer customClass="pull-quote">
            <Star customClass="star--top"/>
              <h3 className="pull-quote__body large">IT’S TIME TO CHIME</h3>
              <p className="pull-quote__body">Chime’s Objectives & MTV’s Campaign Strategy</p>
            <Star customClass="star--bottom"/>
          </InnerContainer>
        </Section>
        <Section>
          <InnerContainer customClass="statistic-blocks">
            <StatisticBlocks blocks={StatisticsContent.blocks}/>
            <StatisticBlocks blocks={InsightBlocks6Content.blocks}/>
          </InnerContainer>
        </Section>
        <Section customClass={["color-block", "bg-green"]}>
          <InnerContainer customClass="pull-quote">
            <Star customClass="star--top"/>
              <h3 className="pull-quote__body large ">That's So Money</h3>
              <p className="pull-quote__body">Program Overview</p>
            <Star customClass="star--bottom"/>
          </InnerContainer>
        </Section>
        <Section customClass="small-boxes">
          <InnerContainer customClass={["small-boxes__container", "threeUp"]}>
            <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={ThreeSmallImages2Content.images[0].image} alt="image" />
            <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={ThreeSmallImages2Content.images[1].image} alt="image" />
            <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={ThreeSmallImages2Content.images[2].image} alt="image" />
          </InnerContainer>
          <InnerContainer customClass="text-block">
            <p className="text-block__body small">{TextBlock2ptFiveContent.body[0].line}</p>
            <p className="text-block__body small">{TextBlock2ptFiveContent.body[1].line}</p>
            <p className="text-block__body small">{TextBlock2ptFiveContent.body[2].line}</p>
          </InnerContainer>
        </Section>
        <Section>
          <InnerContainer customClass="pull-quote">
            <Star customClass="star--top" />
            <p className="pull-quote__body">Campaign Snapshot</p>
            <Star customClass="star--bottom" />
          </InnerContainer>
        </Section>
        <Section>
          <InnerContainer customClass={["statistic-blocks", "two-up", "left", "list-outside"]}>
            <StatisticBlocks blocks={Statistics2Content.blocks}/>
          </InnerContainer>
        </Section>
        <PressQuotes quotes={pressQuote1Content.quotes}/>
        <Section customClass={["color-block", "bg-green"]}>
          <InnerContainer customClass="pull-quote">
            <Star customClass="star--top"/>
              <h3 className="pull-quote__body large ">Kick Off</h3>
              <p className="pull-quote__body">Rallying the Stan Armies</p>
            <Star customClass="star--bottom"/>
          </InnerContainer>
        </Section>
        <EditorialPortrait
          video={PushBNAChatBotVideo}
          blocks={EditorialPortraitContent.blocks}
        />
        <Section customClass={["color-block", "bg-yellow"]}>
          <InnerContainer customClass="pull-quote">
            <Star customClass="star--top" />
            <h1 className="pull-quote__body xlarge">Chatbot Highlights</h1>
            <Star customClass="star--bottom" />
          </InnerContainer>
        </Section>
        <Section>
          <InnerContainer>
            <InsightBlocks blocks={InsightBlocksContent.blocks}/>
          </InnerContainer>
        </Section>
        <Section customClass={["color-block", "bg-yellow"]}>
          <InnerContainer customClass="pull-quote">
            <Star customClass="star--top" />
            <h1 className="pull-quote__body xlarge">SOCIAL VOTING HIGHLIGHTS</h1>
            <Star customClass="star--bottom" />
          </InnerContainer>
        </Section>
        <Section>
          <InnerContainer>
            <InsightBlocks blocks={InsightBlocks2Content.blocks}/>
          </InnerContainer>
        </Section>
        <Section customClass="small-boxes">
          <InnerContainer customClass={["small-boxes__container", "threeUp"]}>
            <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={ThreeSmallImagesContent.images[0].image} alt="image" />
            <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={ThreeSmallImagesContent.images[1].image} alt="image" />
            <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={ThreeSmallImagesContent.images[2].image} alt="image" />
          </InnerContainer>
          <InnerContainer customClass={["small-boxes__container", "threeUp"]}>
            <div className="small-boxes__container__text-block">
              <h2 className="headline"><div>EXCEPTIONAL</div><div>COMMENT RATE</div></h2>
              <h2 className="headline xlarge">5.4x</h2>
              <h3 className="subhead">higher than benchmark</h3>
              <p className="body-copy">With nearly 200 comments total, the kickoff FB post driving followers to the Chatbot created massive buzz around the campaign!</p>
            </div>
            <div className="small-boxes__container__text-block">
              <h2 className="headline"><div>HIGHEST VIDEO</div><div>VIEW RATE</div></h2>
              <h2 className="headline xlarge">77%</h2>
              <h3 className="subhead">higher than benchmark</h3>
              <p className="body-copy">With VVR of 41.4%, fans were glued to the IG video announcing the 17 pre-nominees for PUSH: BEST NEW ARTIST!</p>
            </div>
            <div className="small-boxes__container__text-block">
              <h2 className="headline"><div>HIGHEST</div><div>ORGANIC REACH</div></h2>
              <h2 className="headline xlarge">18.5%</h2>
              <h3 className="subhead">of VMA followers</h3>
              <p className="body-copy">The IG post announcing the top 3 PUSH: BNA finalists reached the most fans of all, along with touting an exceptional click engagement rate 88% higher than benchmark!</p>
            </div>
          </InnerContainer>
        </Section>
        <Section customClass="small-boxes">
          <InnerContainer customClass={["small-boxes__container", "threeUp"]}>
            <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={TwoSmallImagesContent.images[0].image} alt="image" />
            <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={TwoSmallImagesContent.images[1].image} alt="image" />
            <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={TwoSmallImagesContent.images[2].image} alt="image" />
          </InnerContainer>
          <InnerContainer customClass={["small-boxes__container", "threeUp"]}>
            <div className="small-boxes__container__text-block">
              <h2 className="headline"><div>PRE-ROLL</div><div>VIEW RATE</div></h2>
              <h2 className="headline xlarge">53.4%</h2>
              <h3 className="subhead">out-performing</h3>
              <p className="body-copy">TW Amplify’s Entertainment benchmark – a massive win for Chime’s branded creative!</p>
            </div>
            <div className="small-boxes__container__text-block">
              <h2 className="headline"><div>HIGHEST CLICK</div><div>ENGAGEMENT RATE</div></h2>
              <h2 className="headline xlarge">5.5x</h2>
              <h3 className="subhead">higher than benchmark</h3>
              <p className="body-copy">Fans flocked to TW to vote for their favorite top 3 finalist with the highest click engagement rate across the campaign of 18.5% and a click-thru rate of 2.8% - 4.6x higher than benchmark!</p>
            </div>
            <div className="small-boxes__container__text-block">
              <h2 className="headline"><div>EXCEPTIONAL</div><div>ENTHUSIASM</div></h2>
              <h2 className="headline xlarge">99%</h2>
              <h3 className="subhead">ENJOYMENT</h3>
              <p className="body-copy">MTV.COM voters massively enjoyed the voting experience on digital and 92% recalled Chime’s sponsorship within the page!</p>
            </div>
          </InnerContainer>
        </Section>
        <Section customClass={["color-block", "bg-green"]}>
          <InnerContainer customClass="pull-quote">
            <Star customClass="star--top"/>
              <h3 className="pull-quote__body large ">BRINGING BANKING TO YOU</h3>
              <p className="pull-quote__body">How to Hustle with T.I.</p>
            <Star customClass="star--bottom"/>
          </InnerContainer>
        </Section>
        <LargeEditorial
          video={ChimeVotingDeliveryVideo}
          blocks={LargeEditorialContent.blocks}
        />
        <Section>
          <InnerContainer>
            <InsightBlocks blocks={InsightBlocks3Content.blocks}/>
          </InnerContainer>
        </Section>
        <PressQuotes quotes={pressQuote2Content.quotes}/>
        <Section customClass={["color-block", "bg-green"]}>
          <InnerContainer customClass="pull-quote">
            <Star customClass="star--top"/>
              <h3 className="pull-quote__body large ">Pre Show</h3>
              <p className="pull-quote__body">A Tip from TIP</p>
            <Star customClass="star--bottom"/>
          </InnerContainer>
        </Section>
        <LargeEditorial
          video={ChimeVideoPreShow}
          blocks={LargeEditorial2Content.blocks}
        />
        <Section customClass={["color-block", "bg-green"]}>
          <InnerContainer customClass="pull-quote">
            <Star customClass="star--top"/>
              <h3 className="pull-quote__body large ">Main Show</h3>
              <p className="pull-quote__body">THE 2020 VMAS? Why Don’t You Say So…</p>
            <Star customClass="star--bottom"/>
          </InnerContainer>
        </Section>
        <Section>
          <div className="single-image-wave">
            <div className="single-image-wave__image">
              <video controls width="100%">
                <source src={MainShowVideoAct1} type="video/mp4" />
              </video>
            </div>
            <Wave/>
          </div>
        </Section>
        <Section>
          <InnerContainer customClass="text-block">
            <p className="text-block__body small">With two dedicated show moments, Chime received in-show branding and mentions as the Act 1 video package recapped the PUSH: BEST NEW ARTIST award journey from pre-nominees to the top 3, and then rounded out the show teasing the finalists before the winner announcement. Machine Gun Kelly presented the award to hip hop sensation DOJA CAT!</p>
          </InnerContainer>
        </Section>
        <Section>
          <div className="single-image-wave">
            <div className="single-image-wave__image">
              <video controls width="100%">
                <source src={Act9Video} type="video/mp4" />
              </video>
            </div>
            <Wave/>
          </div>
        </Section>
        <Section>
        </Section>
        <Section customClass="small-boxes">
          <ThreeStar/>
          <InnerContainer customClass="text-block">
            <p className="text-block__body small">Chime pumped up their presence night-of-show with MTV’s Twitter by amplifying the first ever PUSH: BEST NEW ARTIST winner’s acceptance speech along with a powerful performance from rapper DaBaby.</p>
          </InnerContainer>
          <InnerContainer customClass={["small-boxes__container", "threeUp"]}>
            <div className="small-boxes__container__image">
              <video controls width="100%">
                <source src={DojaTyTweet} type="video/mp4" />
              </video>
            </div>
            <div className="small-boxes__container__image">
              <p className="small-boxes__container__copy">DaBaby’s performance Tweet accumulated the highest performance of the campaign with over 3.4M+ impressions!</p>
            </div>
            <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={TwoSmallImagesContent.images[3].image} alt="image" />
          </InnerContainer>
          <ThreeStar/>
        </Section>
        <Section customClass={["color-block", "bg-green"]}>
          <InnerContainer customClass="pull-quote">
            <Star customClass="star--top" />
            <h1 className="pull-quote__body xlarge ">…And Beyond!</h1>
            <p className="pull-quote__body">To 2021!</p>
            <Star customClass="star--bottom" />
          </InnerContainer>
        </Section>
        <Section>
          <InnerContainer customClass="text-block">
            <p className="text-block__body small">
            To extend the campaign’s reach past the VMAs, MTV strategically planned to re-version the custom linear promo with T.I. so an evergreen iteration could run until the end of 2020 anywhere across all of ViacomCBS and Chime’s platforms. With awesome partnership hustle, we finalized the spot expeditiously and kicked it off during the main show in local slots so targeted markets experienced Chime messaging during MTV’s biggest night of the year… and beyond!
            </p>
          </InnerContainer>
        </Section>
        <Section>
          <div className="single-image-wave">
            <div className="single-image-wave__image">
              <video controls width="100%">
                <source src={TipsVideo} type="video/mp4" />
              </video>
            </div>
            <Wave/>
          </div>
        </Section>
        <Section>
          <InnerContainer customClass="text-block">
            <p className="text-block__body small">
            As an extended Twitter Amplify post, Chime utilized the evergreen piece as pre-roll leading into a throwback clip from Family Hustle as T.I. describes his 360 approach to success, proving that “TIP’s Tips” will get your money right.
            </p>
          </InnerContainer>
        </Section>
        <Section customClass={["color-block", "bg-green"]}>
          <InnerContainer customClass="pull-quote">
            <Star customClass="star--top" />
            <h1 className="pull-quote__body xlarge ">PARTNERSHIP WINS</h1>
            <p className="pull-quote__body">Chime + VMAs = ♥</p>
            <Star customClass="star--bottom" />
          </InnerContainer>
        </Section>
        <Section>
          <InnerContainer customClass={["statistic-blocks", "four-up"]}>
            <StatisticBlocks blocks={Statistics3Content.blocks}/>
          </InnerContainer>
        </Section>
        <Section>
          <InnerContainer>
            <Star/>
          </InnerContainer>
        </Section>
        <Section>
          <InnerContainer customClass="insight-blocks">
            <InsightBlocks headline={InsightBlocks4Content.headline} blocks={InsightBlocks4Content.blocks}/>
          </InnerContainer>
          <InnerContainer customClass={"InsightBlocks"}>
            <InsightBlocks blocks={Statistics5Content.blocks}/>
          </InnerContainer>
        </Section>
        <Section>
          <InnerContainer>
            <Star/>
          </InnerContainer>
        </Section>
        <PressQuotes quotes={pressQuote3Content.quotes}/>
    </Main>
  )
}
export default Chime
